/**
  * A collection of utility functions
  * for scraping and manipulating JSON
  * dumps created in Shopify's Liquid 
  * (see json-xxx.liquid files in snippets)
  */

/**
 * Often when a Shopify ID is referenced
 * it is the full GraphQL ID string qualifying
 * the model. This returns an int ID and assumes you
 * know what model you're referencing.
 */
function getIdFromGid(gid) {
  return parseInt(gid.replace(/\D+/g, ""));
}

function getProductIDFromUrl() {
  const queryParams = window.location.search;
  const match = queryParams.match(/id=(\d+)/);

  if (!match) {
    return null;
  }

  return parseInt(match[1]);
}

function getProducts() {
  return JSON.parse(document.getElementById("products-json").textContent);
}

function getBatches() {
  const batches = JSON.parse(
    document.getElementById("batches-json").textContent,
  );

  return batches.map((batch) => {
    batch.harvest = getIdFromGid(batch.harvest);
    batch.products = batch.products.map((product) => getIdFromGid(product));
    return batch;
  });
}

function filterBatchesByProduct(productID, batches) {
  return batches.filter((batch) => batch.products.includes(productID));
}

function getHarvests() {
  const harvests = JSON.parse(
    document.getElementById("harvests-json").textContent,
  );

  return harvests.map((harvest) => {
    harvest.grain = getIdFromGid(harvest.grain);
    harvest.farm = getIdFromGid(harvest.farm);
    return harvest;
  });
}

function getGrains() {
  return JSON.parse(document.getElementById("grains-json").textContent);
}

function getFarms() {
  return JSON.parse(document.getElementById("farms-json").textContent);
}
